module.exports = __webpack_public_path__ + "static/media/W2@1.5x.cbd48e0a.png";